import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { Users, Briefcase, Target, Building2 } from 'lucide-react';
import PanelHeader from '../../components/PanelHeader';
import UserManagement from './UserManagement';
import ProfessionManagement from './ProfessionManagement';
import PositionManagement from './PositionManagement';
import BranchManagement from './BranchManagement';

export const AdminPanel = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/admin/users', icon: Users, label: 'Kullanıcılar' },
    { path: '/admin/professions', icon: Briefcase, label: 'Meslekler' },
    { path: '/admin/positions', icon: Target, label: 'Görevler' },
    { path: '/admin/branches', icon: Building2, label: 'Şubeler' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-[hsl(var(--background))]" data-testid="admin-panel">
      {/* Header */}
      <PanelHeader
        logoSrc="https://customer-assets.emergentagent.com/job_independent-erp/artifacts/prgex85y_18_01_2025_fortis_kurumsal_logolar.svg"
      >
        <h1 className="text-2xl font-bold uppercase tracking-wide">ADMİN PANELİ</h1>
      </PanelHeader>

      {/* Add pt-16 to account for fixed header height (h-16 = 4rem) */}
      <div className="flex pt-16">
        {/* Sidebar */}
        <aside className="w-64 min-h-[calc(100vh-4rem)] border-r border-[hsl(var(--border))] bg-white p-4">
          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-md transition-colors ${
                    isActive(item.path)
                      ? 'bg-[hsl(var(--brand-700))] text-white'
                      : 'hover:bg-[hsl(var(--muted))] text-[hsl(var(--foreground))]'
                  }`}
                  data-testid={`admin-menu-${item.label.toLowerCase()}`}
                >
                  <Icon className="h-5 w-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-6">
          <Routes>
            <Route path="/users" element={<UserManagement />} />
            <Route path="/professions" element={<ProfessionManagement />} />
            <Route path="/positions" element={<PositionManagement />} />
            <Route path="/branches" element={<BranchManagement />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;
